module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAASwAAAA8BAMAAAAu8pppAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAASUExURUJCQkJCQkJCQkJCQkJCQkJCQpjrSUsAAAAFdFJOUwG2R9GBsFvi6gAAAAlwSFlzAAAASAAAAEgARslrPgAAAQVJREFUaN7t2r0OgyAUhmG07c6gO4u7ie1O03QH9Nz/rbQWfzBh503qdwVPgJwDHpXaUz8HKZahMSqblxROk0HVrRSPN0RVxoVQfV1HVSeQhFR1FUwsbwvnjLvqIqD0G+tBYm3LVQkqemG9WaxpqaQCS6ypNxrL0apDUupxexh3seKxNKkdHhtjy2PNh0uAQV0e0mtERWRpXjGNBbUjsgKtT6/duiWyPOsKuF8FoSxB5mSdrP868lCWZ7ImJiswWY7J0kyWZbKYDx/PZAUmSzNZBsmCvvUdk2WQrN8nXR6rR7LiuIC5WIpYHYAsi2StY07kFsJYoyGyksE+SHVPxtQU0/Fnlg+dmkw7Y2HPqgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/images/pay/discounts.png
// module id = 818
// module chunks = 0